import { createStore } from "redux";

import { persistStore, persistReducer } from "redux-persist";

import session from "redux-persist/lib/storage/session";

import reducers from "./ducks/index"; // nome qualquer que dei ao importar o reducer!

const persistConfig = {
    key: "root",
    // @ts-ignore
    storage: session?.default || session,
    whitelist: [
        // * Apenas salva o login no localstorage quando estiver em desenvolvimento, evita ter que ficar logando toda hora
        "loginreducer",
        "vistoriareducer",
        "avariasreducer",
        "avariasOEAreducer",
        "lacrereducer",
        "detalheISOreducer",
        "navigationBarreducer",
        "preparaRemocaoReducer",
        "detalheCarregaGateReducer",
        "detalheDescarregaGateReducer",
        "carregaGateReducer",
        "descarregaGateReducer",
        "controleReeferReducer",
        "detalheGateReducer",
        "autorizarEntradaReducer",
        "motivoPickupContainerReducer",
        "consultasGeraisReducer",
        "armazemGeralReducer",
        "entrepostoReducer",
        "inventarioReducer",
        "carregaDescarregaVolumeMercadoriaReducer",
        "avariasCargaSoltaReducer",
        "solServReducer",
        "desovaReducer",
        "iniciarDesovaReducer",
        "solServDesovaReducer",
        "remocaoVolumeReducer",
        "edicaoVolumesReducer",
        "operacaoContainerReducer",
        "remontagemVolumeReducer",
        "aplicativoReducer",
        "avariaMovimentacaoVolumeReducer",
        "carregamentoPosDescargaReducer",
        "pesquisaReducer",
        "tipoImagemReducer",
        "obterSkillReducer"
    ] // Colocar os reducers que desejamos salvar em localstorage
    //blacklist: ['duckmxalerta'] // Colocar os reducers que desejamos "Não" salvar em localstorage
    // blacklist: ["loginreducer"] // * garante que o que o usuário não permaneça logado entre as sessões
};

const persistedReducer = persistReducer(persistConfig, reducers);

/**
 * @type {import("redux").Store<ReturnType<typeof reducers>,any> }
 */
const store = createStore(persistedReducer);

const persistor = persistStore(store);

export { store, persistor };
